import { SupabaseCatalogRepository } from './supabaseCatalogRepository.js';

const LEGACY_DATABASE_NAME='toybox-catalog-studio';

function discardLegacyLocalCatalog(){
  if(typeof indexedDB==='undefined')return Promise.resolve();
  return new Promise((resolve)=>{
    const request=indexedDB.deleteDatabase(LEGACY_DATABASE_NAME);
    request.addEventListener('success',()=>resolve(),{once:true});
    request.addEventListener('error',()=>resolve(),{once:true});
    request.addEventListener('blocked',()=>resolve(),{once:true});
  });
}

export class CatalogRepository{
  constructor(){
    this.remote=new SupabaseCatalogRepository();
  }

  get configured(){return this.remote.configured;}
  get session(){return this.remote.session;}
  get membership(){return this.remote.membership;}
  canRead(){return this.remote.canRead();}
  canEdit(){return this.remote.canEdit();}
  canPublish(){return this.remote.canPublish();}

  async initialize(){
    await discardLegacyLocalCatalog();
    return this.remote.initialize();
  }

  onAuthStateChange(callback){return this.remote.onAuthStateChange(callback);}
  signIn(email,password){return this.remote.signIn(email,password);}
  signUpFirstAdmin(email,password){return this.remote.signUpFirstAdmin(email,password);}
  signOut(){return this.remote.signOut();}
  refreshMembership(){return this.remote.refreshMembership();}

  async list(){
    if(!this.canRead())return [];
    return this.remote.list();
  }

  async get(id,options){
    if(!this.canRead())return null;
    return this.remote.get(id,options);
  }

  async save(item,options){
    if(!this.canEdit()){
      throw new Error('Iniciá sesión con permiso de edición para guardar en el catálogo.');
    }
    return this.remote.save(item,options);
  }

  async remove(id){
    if(!this.canEdit()){
      throw new Error('Iniciá sesión con permiso de edición para eliminar del catálogo.');
    }
    return this.remote.remove(id);
  }

  async publish(id){
    return this.remote.publish(id);
  }
}
